define.alias("shared/components/shared/wizards/device-setup", "calendar/components/shared/wizards/device-setup");